/**
 * 获取当前登录用户的详情
 */
export async function fetchUserInfo(
  accessToken?: string | null
): Promise<User.Info> {
  if (!useAccessToken().value || !accessToken) {
    return {
      login: false,
      user: {}
    } as any
  }
  return http
    .get<User.Info>('/v1/user/info')
    .then((res) => {
      if (res.data) {
        return res.data
      } else {
        useAccessToken().value = null
        return {
          login: false,
          user: {}
        } as any
      }
    })
    .catch(() => {
      useAccessToken().value = null
      return {
        login: false,
        user: {}
      } as any
    })
}
